import React, { forwardRef, useImperativeHandle } from 'react';
import { TablePlus } from '../../../../../components';
import { useTable } from '../../../../../hooks/index.hook';
import {
  Columns,
  getUserService,
  updateBookingReviewService,
  deleteBookingReviewService,
  getBookingReviewByIdService,
} from '../../../../../services/index.service';
import {
  ModalWrapper,
  EditReviewForm,
} from '../../../../../components';
import { modalNotification, dateFormatter } from '../../../../../utils';
import { useTranslation } from 'react-i18next';
import { getFullName } from '../../../../../utils/text.util';
import { DATE_TH_MONTH_YEAR_TIME } from '../../../../../config';
import { useEffect } from 'react';

const ReviewUserList = forwardRef(({ defaultKey }, ref) => {
  const { t } = useTranslation();
  const [state, setState] = React.useState({
    modal: null,
    modalData: null,
    isLoading: false,
  });

  const { modal, modalData, isLoading: isSubmitLoading } = state;
  const extraCSVHandle = async (getData) => {
    let obj = {};
    let arr = [];
    getData &&
      getData?.rows?.length &&
      getData?.rows?.map((item) => {
        if (item?.toUser?.avgUserRating) {
          obj = {
            name: item?.toUser?.avgUserRating
              ? item?.toUser?.avgUserRating
              : '0.0',
          };
          arr.push(obj);
        }
      });
    return { averageRating: arr };
  };
  const [tableHandler, tableProps] = useTable(
    getUserService,
    false,
    false,
    false,
    false,
    extraCSVHandle
  );

  const {
    data,
    isLoading,
    count,
    page,
    noOfPages,
    sizePerPage,
    filter,
    sortBy,
    sortType,
  } = tableProps;
  const {
    onFilterChange,
    onExport,
    onFilterResetChange,
    onTableSort,
    onRefresh,
    onConfirmDeleteAlert,
  } = tableHandler;

  const onAction = async (type, row) => {
    if (type === 'EDIT') {
      setState({ ...state, isLoading: true });
      try {
        const res = await getBookingReviewByIdService(row?.id);
        if (res?.success) {
          setState({
            ...state,
            modal: 'EDIT_REVIEW',
            modalData: {
              ...res.data,
              providerName: getFullName(
                res.data?.User?.firstName,
                undefined,
                res.data?.User?.lastName
              ),
              userName: getFullName(
                res.data?.toUser?.firstName,
                undefined,
                res.data?.toUser?.lastName
              ),
              date: dateFormatter(res.data?.createdAt, DATE_TH_MONTH_YEAR_TIME),
            },
            isLoading: false,
          });
        }
      } catch (error) {
        setState({ ...state, isLoading: false });
      }
    } else if (type === 'DELETE') {
      onConfirmDeleteAlert({
        id: row?.id,
        text: t('text.common.areYouSure'),
        service: () => deleteBookingReviewService(row?.id),
      });
    }
  };

  const columns = Columns.reviewUserColumn({
    onSort: onTableSort,
    onFilterChange: onFilterChange,
    filter,
    page,
    sizePerPage,
    onAction,
  });

  useEffect(() => {
    onFilterResetChange();
  }, [defaultKey]);

  async function fetchData() {
    try {
      let res = await onExport('', columns);
      return res;
    } catch (error) {
      console.error(error);
    }
  }

  useImperativeHandle(ref, () => ({
    fetchData,
  }));

  return (
    <>
      <ModalWrapper
        show={modal === 'EDIT_REVIEW'}
        onCancel={() => setState({ ...state, modal: null })}
        heading={t('text.report.editReview')}
        width={700}
        content={
          <EditReviewForm
            initialValues={modalData}
            isLoading={isSubmitLoading}
            onCancel={() => setState({ ...state, modal: null })}
            onSubmit={async (values) => {
              setState({ ...state, isLoading: true });
              try {
                const res = await updateBookingReviewService(modalData.id, {
                  rating: values.rating,
                  review: values.review,
                });
                if (res?.success) {
                  modalNotification({
                    type: 'success',
                    message: res.message,
                  });
                  setState({ ...state, modal: null, isLoading: false });
                  onRefresh();
                }
              } catch (error) {
                setState({ ...state, isLoading: false });
              }
            }}
          />
        }
      />
      <TablePlus
        hasLimit
        noOfPage={noOfPages}
        sizePerPage={sizePerPage}
        page={page}
        count={count}
        tableData={data}
        tableColumns={columns}
        tableLoader={isLoading}
        onFilterResetChange={onFilterResetChange}
        showAction={false}
        selectRow="false"
        filter={filter}
        sortBy={sortBy}
        sortType={sortType}
      />
    </>
  );
});
export default ReviewUserList;
